// Single source of truth for dayjs plugins/locales - imported by both `legacy-libs.js` (Vite)
// and `public_dashboard-esbuild.js` (standalone esbuild entry, not part of the Vite build graph)
// so the two independent bundles can't drift out of sync with each other. Replaces `moment`,
// which is in maintenance mode - see window.DT.dt() in common.js for the first migrated caller.
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

import 'dayjs/locale/en';
import 'dayjs/locale/fi';
import 'dayjs/locale/fr';
import 'dayjs/locale/sv';

[utc, isBetween, isSameOrBefore, isoWeek, quarterOfYear, customParseFormat, relativeTime]
  .forEach((plugin) => dayjs.extend(plugin));

export default dayjs;
